import { gql } from '@apollo/client'
import { CORE_USER_FIELDS } from './fragments/user'

export const UPDATE_EMAIL = gql`
  ${CORE_USER_FIELDS}
  mutation updateEmail($email: String!, $currentPassword: String!) {
    updateEmail(email: $email, currentPassword: $currentPassword) {
      ...CoreUserFields
    }
  }
`
